<template>
  <v-app>
    <tt-app-bar
      v-if="$auth.isAuthenticated"
      color="white"
      :portal-url="portalUrl"
      :buttons="moduleButtons"
      :menu-items="menuItems"
    />

    <v-main>
      <Message />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import EnvProvider from "@tt/vue-environment/EnvProvider";
export default {
  name: "App",
  data: () => ({
    portalUrl: EnvProvider.value("PORTAL_URL"),
    moduleButtons: []
  }),
  computed: {
    menuItems() {
      return this.$router.options.routes
        .filter(item => {
          return !(item.menuTitle === undefined && item.menuIcon === undefined);
        })
        .filter(item => {
          return item.active === true;
        });
    }
  },
  // mounted: async function() {
  //   const token = await this.$auth.getTokenSilently();
  //   const tokenClaims = await this.$auth.getIdTokenClaims();
  //   console.log(token, tokenClaims);
  // },
};
</script>
